import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './components/home_block/favyt/Home';
import Dashboard from './components/home_block/business-xchange/Dashboard';
import Services from './components/services_block/Services';
import TechnologyServices from './components/services_block/services_technology_block/Technology';
import FinancialServices from './components/services_block/services_financial_block/Financial';
import ManagementServices from './components/services_block/services_management_block/Management';
import BusinessServices from './components/services_block/services_business_block/Business';
import DueDiligenceServices from './components/services_block/services_due_dilligence_block/DueDilligence';
import EntrepreneureClubServices from './components/services_block/services_entrepreneure_club_block/EntrepreneureClub';
import Registration from './components/registration_block/Registration';
import BusinessRegistration from './components/registration_block/business_block/Business';
import FranchieseRegistration from './components/registration_block/franchise_block/Franchise';
import InvestorRegistration from './components/registration_block/investor_block/Investor';
import LenderRegistration from './components/registration_block/lender_block/Lender';
import MentorRegistration from './components/registration_block/mentor_block/Mentor';
import StartupRegistration from './components/registration_block/startup_block/Startup';
import Listing from './components/listing_block/Listing';
import BusinessListing from './components/listing_block/business_block/Business';
import FranchieseListing from './components/listing_block/franchise_block/Franchise';
import InvestorListing from './components/listing_block/investor_block/Investor';
import LenderListing from './components/listing_block/lender_block/Lender';
import MentorListing from './components/listing_block/mentor_block/Mentor';
import StartupListing from './components/listing_block/startup_block/Startup';
import Aboutus from './components/aboutus_block/Aboutus';
import ContactUs from './components/contact_us_block/ContactUs';
import MyProfile from './components/myprofile_block/MyProfile';
import Login from './components/account_block/Login';
import Signup from './components/account_block/Signup';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import NavBar from './components/nav_bar_block/NavBar';

const App = () => (
  <div>
    <NavBar />
    <div>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/signup" element={<Signup />} />
        <Route exact path="/" element={<Home />} />
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/registration" element={<Registration />} />
        <Route exact path="/registration/business" element={<BusinessRegistration />} />
        <Route exact path="/registration/franchiese" element={<FranchieseRegistration />} />
        <Route exact path="/registration/investor" element={<InvestorRegistration />} />
        <Route exact path="/registration/lender" element={<LenderRegistration />} />
        <Route exact path="/registration/mentor" element={<MentorRegistration />} />
        <Route exact path="/registration/startup" element={<StartupRegistration />} />
        <Route exact path="/listing" element={<Listing />} />
        <Route exact path="/listing/business" element={<BusinessListing />} />
        <Route exact path="/listing/franchiese" element={<FranchieseListing />} />
        <Route exact path="/listing/investor" element={<InvestorListing />} />
        <Route exact path="/listing/lender" element={<LenderListing />} />
        <Route exact path="/listing/mentor" element={<MentorListing />} />
        <Route exact path="/listing/startup" element={<StartupListing />} />
        <Route exact path="/services" element={<Services />} />
        <Route exact path="/services/technology" element={<TechnologyServices />} />
        <Route exact path="/services/financial" element={<FinancialServices />} />
        <Route exact path="/services/management" element={<ManagementServices />} />
        <Route exact path="/services/business" element={<BusinessServices />} />
        <Route exact path="/services/duediligence" element={<DueDiligenceServices />} />
        <Route exact path="/services/entrepreneureclub" element={<EntrepreneureClubServices />} />
        <Route exact path="/aboutus" element={<Aboutus />} />
        <Route exact path="/contactus" element={<ContactUs />} />
        <Route exact path="/profile" element={<MyProfile />} />
        <Route exact path="*" element={<Home />} />
      </Routes>
    </div>
  </div>
);

export default App;
